import React, { useState,useEffect } from 'react';
import { BASE_URL } from '../utils/config';
import ReactSelect from 'react-select'
import Loading from './loading';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { Dialog} from '@mui/material';

const NKBSection = ({ stockSymbols, IntraDaychecked, requestToken, commenteryData, isEditable, onNKBSectionChange, onOptionStockSelect, onRemoveFile, onStockLossRecord, generateImage }) => {
  const [nkbSectionState, setNkbSectionState] = useState({
    nkbReportType: 'CALL',
    stockType: '',
    optionCMP: '',
    optionSL: '0',
    stockIncToken: '',
    optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
    commentry: '',
    chartImageInterval:'1D'
  });
 const allowedValues = ["NIFTY", "SENSEX", "MIDCPNIFTY", "BANKNIFTY"];

const options = stockSymbols
  .filter((data) =>
    allowedValues.includes(data.name?.toUpperCase())
  )
  .map((data) => ({
    ...data,
    value: data.name,
    label: data.name,
  }));
  const customStyles = {
    // Define your custom styles here
    menu: (provided) => ({
      ...provided,
      width: '256px',
      marginLeft: '185px'
    }),
    control: (provided, state) => ({
      ...provided,
      width: '256px', // Set the desired width for the entire component
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : null,
      '&:hover': {
        border: '1px solid #2684FF',
      },
    }),
    // Add more styles for other elements as needed
  };
  const [SelectedStockRecord,setSelectedStockRecord]=useState({}); 
  const [optioncmperror, setOptionCmpError] = useState(false)
  const [slerror, setSlError] = useState(false)
  const [CmpErrorMsz, setCmpErrorMsz] = useState('')
  const [showCmpApiError, setShowCmpApiError] = useState(false)
  const [stopLossData, setStopLossData] = useState([])
  const [loading, setLoading] = useState(false);
  const [showAlert, setshowAlert] = useState(false);
  const [AlertMessage, setAlertMessage] = useState("");


  let RemarkText = 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'



  useEffect(() => {
    const getSelectedCommentary = (type) => {
      const label = type === 'CALL' ? 'Call 1' : 'Put 1';
      console.log("label",label)
      return commenteryData.find(data => data.CommentaryName === label) || null;
    };

    const selectedData = getSelectedCommentary(nkbSectionState.nkbReportType);
    setNkbSectionState((prevState) => {
      const newState = {
        ...prevState,
        commentry: selectedData?.Description || '',
      };

      // Log the updated state
      console.log("OptionSectionState", newState);

      // Notify the parent component about the change
      onNKBSectionChange(newState);
     
      return newState;
    });
  }, [commenteryData]);

  // handle input change for all inputs
  const handleInputChange = (event) => {
    setOptionCmpError(false);
    setSlError(false);
    const { name, value } = event.target;
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setNkbSectionState((prevState) => {
        let newState
     
        if (name === 'optionSL' && value == '0') {

          newState = {
            ...prevState,
            [name]: value,
            optionRemark: RemarkText
          };
        }
        else if (name === 'optionSL' && value != '0') {
          newState = {
            ...prevState,
            [name]: value,
            optionRemark: ""
          };
        }
        else {
          newState = {
            ...prevState,
            [name]: value,

          };
        }


        // Log the updated state
        console.log("OptionSectionState", newState);

        // Notify the parent component about the change
        onNKBSectionChange(newState);

        return newState;
      });
    }
    else {
      if (name === 'optionCMP') {
        setOptionCmpError(true)
        setTimeout(() => {
          setOptionCmpError(false)
        }, 2000);
      }
      else if (name === 'optionSL') {
        setSlError(true)
        setTimeout(() => {
          setSlError(false)
        }, 2000);
      }
    }

  };



// handle change radio button call and put
  const handleChange = (event) => {

    const { name, value } = event.target;


    if(name === 'nkbReportType'){
      const getSelectedCommentary = (type) => {
        const label = type === 'CALL' ? 'Call 1' : 'Put 1';
        console.log("label",label)
        return commenteryData.find(data => data.CommentaryName === label) || null;
      };
  
      const selectedData = getSelectedCommentary(value);
      setNkbSectionState((prevState) => {
        const newState = {
          ...prevState,
          [name]: value,
          commentry: selectedData?.Description || '',
          stockType: '',
    optionCMP: '',
    optionSL: '0',
    stockIncToken: '',
    optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
    chartImageInterval:'1D'
        };
  
        // Log the updated state
        console.log("OptionSectionState", newState);
  
        // Notify the parent component about the change
        onNKBSectionChange(newState);
       
      
        setStopLossData([]);
       
        return newState;
      });
    }else{
    setNkbSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };

      // Log the updated state
      console.log("OptionSectionState", newState);

      // Notify the parent component about the change
      onNKBSectionChange(newState);

      return newState;
    });
  }


  };

// handle change for chart interval
  const handleChartinterval = (event) => {

    const { name, value } = event.target;

     if (!nkbSectionState.stockType) {
    console.log("Stock symbol not available. Skipping interval change.");
    setAlertMessage(`Please Select Stock Name First then try to change the Image Interaval.`);
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 3000);
    return;
  }
    setNkbSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };

      // Log the updated state
      console.log("OptionSectionState", newState);

      // Notify the parent component about the change
      onNKBSectionChange(newState);


      generateImage(SelectedStockRecord.TV_STOCK_Symbol, SelectedStockRecord.TVExchange,value)
      return newState;
    });


    


  };

  // handle change for stock name select
  const handlechangestock = async (event) => {
    // const { name, value } = event.target;

    setLoading(true)
    let selectedStockRecord
    let type 
    if(event.value === 'SENSEX'){
     type = 'BFO-OPT';
    }else{
      type = 'NFO-OPT';
    }
    let last_price
    let Expiry_date

    const getSelectedCommentary = (type) => {
      const label = type === 'CALL' ? 'Call 1' : 'Put 1';
      console.log("label",label)
      return commenteryData.find(data => data.CommentaryName === label) || null;
    };

    const selectedData = getSelectedCommentary(nkbSectionState.nkbReportType);
    setNkbSectionState((prevState) => {
      const newState = {
        ...prevState,
        stockType: event.value,
        optionCMP: "",
        optionSL: '0',
        stockIncToken: '',
        optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
        commentry: selectedData?.Description || ''

      };

      // Log the updated state
      // console.log("OptionSectionState", newState);
      onRemoveFile();
    
      selectedStockRecord = stockSymbols.find(item => item.name === event.value);

      console.log("selectedStockRecord inside setoptiondata", selectedStockRecord);

      setSelectedStockRecord(selectedStockRecord);

      onOptionStockSelect(selectedStockRecord);
      onNKBSectionChange(newState);
      generateImage(selectedStockRecord.TV_STOCK_Symbol, selectedStockRecord.TVExchange,nkbSectionState.chartImageInterval)

      return newState;
    });

 
   
    setStopLossData([]);
   


      

    console.log("selectedStockRecord outsiden setoptiondata", selectedStockRecord);

    let url
   
      console.log("insdie else to call api of cmp price ")
      if ( event.value) {
      url = `${BASE_URL}/getcmpprice/${event.value}/NKB/expiry`;
      } else {
        setCmpErrorMsz(`Error: Missing required API values ( stock name, or expiry date).`)
        setShowCmpApiError(true);
       
        setTimeout(() => {
        setShowCmpApiError(false);
        setCmpErrorMsz('')
        }, 2000);
        return
      }
    
    // get cmp of stock
    try {
      const response = await fetch(`${url}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
      },
      });

      if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
      }

      const res = await response.json();
      console.log(res);

      if (res.success === true) {
      console.log("res.data for cmp price -====", res);

    
        let Stock_IncToken = res.stock_IncToken;
        last_price = res.instruments.last_price;
        let SL = 0
        if(nkbSectionState.nkbReportType === "CALL"){
         SL = last_price - 300;
        }else{
            SL = last_price + 300;
        }
       
        setNkbSectionState((prevState) => {
        const newState = {
          ...prevState,
          optionCMP: last_price,
          stockIncToken: Stock_IncToken,
          optionSL:SL,
          optionRemark:SL=== 0 ?nkbSectionState.optionRemark:""
        };

        console.log("OptionSectionState", newState);
        onNKBSectionChange(newState);
        return newState;
        });

        setLoading(false)
      
      } else {
        setCmpErrorMsz(`Error: ${res.message}`)
      setShowCmpApiError(true);
      setNkbSectionState((prevState) => {
        const newState = {
        ...prevState,
        optionCMP: "",
        stockIncToken: '',
        };

        console.log("OptionSectionState", newState);
        onNKBSectionChange(newState);
        return newState;

      });
      setTimeout(() => {
        setShowCmpApiError(false);
      setCmpErrorMsz('')
      }, 2000);
  setLoading(false)
      return
        
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setCmpErrorMsz(`Error: ${error.message}`)
      setShowCmpApiError(true);
      setNkbSectionState((prevState) => {
      const newState = {
        ...prevState,
        optionCMP: "",
      };

      console.log("OptionSectionState", newState);
      onNKBSectionChange(newState);
      return newState;
      });
      setTimeout(() => {
      setShowCmpApiError(false);
      setCmpErrorMsz('')
      }, 2000);
      setLoading(false)
      return
    }



  };





  // handle change for Commentry
  const handleOptionChange = (event) => {
    const { name, value } = event.target;
    const selectedValue = event.target.value;
    setNkbSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };
      onNKBSectionChange(newState);

      const selectedData = commenteryData.find((data) => data.Description === selectedValue);
      console.log("selectedData", selectedData);
      
      return newState;
    });
  };

  // handle Fetch api for cmp price
  const fetchCMP = async (event) => {
    event.preventDefault();
    const StockName = nkbSectionState.stockType
    console.log("StockName", StockName);
    let url
    if (!StockName || !nkbSectionState.Expiry ) {
      setCmpErrorMsz("Error: Missing required API values (Stock Name, Expiry, or Request Token).");
      setShowCmpApiError(true);
      setTimeout(() => {
      setShowCmpApiError(false);
      setCmpErrorMsz('');
      }, 2000);
      return;
    }

    if (IntraDaychecked) {
      url = `${BASE_URL}/getcmpprice/${StockName}/${'IntraDay'}/${nkbSectionState.Expiry}`;
    } else {
      url = `${BASE_URL}/getcmpprice/${StockName}/${requestToken}/${nkbSectionState.Expiry}`;
    }

    await fetch(`${url}`, {
      method: 'GET',
      headers: {
      "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
      // Process the API response data
      console.log(res);

      if (res.success === true) {
        console.log("res.data", res.instruments);
        let last_price = res.instruments.last_price;

        setNkbSectionState((prevState) => {
        const newState = {
          ...prevState,
          optionCMP: last_price,
        };

        // Log the updated state
        console.log("OptionSectionState", newState);

        // Notify the parent component about the change
        onNKBSectionChange(newState);

        return newState;
        });

       
      } else {
        setCmpErrorMsz(res.message || "Error fetching CMP price.");
        setShowCmpApiError(true);
        setNkbSectionState((prevState) => {
        const newState = {
          ...prevState,
          optionCMP: "",
        };

        console.log("OptionSectionState", newState);
        onNKBSectionChange(newState);

        return newState;
        });
        setTimeout(() => {
        setShowCmpApiError(false);
        setCmpErrorMsz('');
        }, 2000);
      }
      })
      .catch(error => {
      setCmpErrorMsz(`Error: ${error.message}`);
      setShowCmpApiError(true);
      setNkbSectionState((prevState) => {
        const newState = {
        ...prevState,
        optionCMP: "",
        };

        console.log("OptionSectionState", newState);
        onNKBSectionChange(newState);

        return newState;
      });
      setTimeout(() => {
        setShowCmpApiError(false);
        setCmpErrorMsz('');
      }, 2000);
      console.error('Error fetching data:', error);
      });
  }


// handle clear stoploss data array
  const clearStoplossData = () => {
    let newArray = stopLossData.map(({ OptionstopLoss, ...rest }) => rest);
    setStopLossData(newArray);
  }




  


  return (
    <div className="optionmain">
      {loading ?
        <div style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 2,
        }}>
          <Loading />
        </div> : null}
      <div id="btnoptionDiv" className="btnoptiondiv">
        <p>BUY</p>
        <input type="radio" value="CALL" defaultChecked name="nkbReportType" onChange={handleChange} />

        <p>SELL</p>
        <input type="radio" value="PUT" name="nkbReportType" onChange={handleChange} />
      </div>

      <div id="option_content" className="optioncontent">
      <div>
          <p>Chart-Image Interval:</p>
          <select value={nkbSectionState.chartImageInterval} id="chartImageInterval" name="chartImageInterval" onChange={handleChartinterval}>
  <option value="4h">4h</option>
  <option value="1D">1D</option>
  <option value="1W">1W</option>
  <option value="1M">1M</option>
  <option value="1Y">1Y</option>
</select>
        </div>
        <div>
          <p>Stock Name:<span className='asterisk'>*</span></p>
         

          <ReactSelect
            id="OptionStocktype"
            name="stockType"
            options={options}
            onChange={handlechangestock}
            styles={customStyles}
            disabled={!isEditable}
          />
        </div>

       

        {optioncmperror ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}
        {showCmpApiError ? <span style={{ color: 'red', fontSize: '15px' }}>{CmpErrorMsz}</span> : null}
        <div style={{ marginTop: '16px' }}>
          <p>UnderLying Price:<span className='asterisk'>*</span></p>
          <button class="fetch" style={{ cursor: nkbSectionState.stockType == '' ? 'not-allowed' : 'pointer' }} disabled={nkbSectionState.stockType == ''} onClick={fetchCMP}>Fetch</button>
          <input value={nkbSectionState.optionCMP} type="number" id="optioncmp" name="optionCMP" required onChange={handleInputChange} disabled={!isEditable} />
        </div>

     


        {slerror ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}
        <div>

          <p>SL :<span className='asterisk'>*</span></p>
        

          {stopLossData.length > 0 && stopLossData.some(data => data.OptionstopLoss) ? (
            <>
              <select style={{ width: '49%' }} id="Optionsl" name="optionSL" value={nkbSectionState.optionSL}  disabled={!isEditable}>
                <option value="">Select SL</option>
                {stopLossData.map((data, index) => (
                  <option key={index} value={data.OptionstopLoss}>
                    {data.OptionstopLoss}
                  </option>
                ))}
              </select>
              <span style={{ cursor: 'pointer' }} className="clear-icon" onClick={clearStoplossData}><DriveFileRenameOutlineIcon style={{ color: 'red' }} /></span>
            </>
          ) : (
            <input value={nkbSectionState.optionSL} type="number" id="Optionsl" name="optionSL" required onChange={handleInputChange} disabled={!isEditable} />

          )}  </div>
      

      


        <div>
          <p>Select commentary:<span className='asterisk'>*</span></p>
          <select id="selectcommentry" name="commentry" value={nkbSectionState.commentry} onChange={handleOptionChange} disabled={!isEditable}>
            <option value="">Select commentary</option>
            {commenteryData.map((data) => (
              <option key={data.CommentaryName} value={data.Description}>
                {data.CommentaryName}
              </option>
            ))}
          </select>
         
        </div>


        <div>
          <p>Commentary Remarks:</p>
          <textarea style={{
            border: `2px solid ${nkbSectionState.optionSL == '0' ? 'red' : 'rgba(0, 0, 0, 0.2)'}`,
            outline: 'none',
          }} value={nkbSectionState.optionRemark} id="optionremark" name="optionRemark" required rows={4} onChange={handleChange} disabled={!isEditable} />
        </div>

       
      </div>

         <Dialog
                          open={showAlert}
                          onClose={() => { setshowAlert(false) }}
                          aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description"
                        >
                          <p style={{ color: "green", padding: '10px 30px 10px 30px', margin: 0 }}>{AlertMessage}</p>
                        </Dialog>
    </div>
  );
};

export default NKBSection;
